/**
 * Confirmation copy for ending a family friendship. It must say exactly
 * what DELETE /family/friendship/:id removes (api-worker
 * friendship.controller.ts -> @kiddy-cash/data
 * FamilyFriendshipRepository.endFriendship):
 *
 * - removed: the connection itself, and the kid-to-kid connections that
 *   only exist between the two families (blocked ones, siblings, and kids
 *   still linked through another friend family are kept);
 * - notified: both families' managers and the kids who lose a connection;
 * - kept: goal contributions already made (money moves are permanent).
 *   Allowances, tasks and loans are never shared between families, so
 *   there is nothing to cancel.
 */
export const END_FRIENDSHIP_MESSAGE =
    'This ends the connection between your families. ' +
    'Kid connections between the two families are removed too, and both ' +
    "families' managers and those kids are told. " +
    'Money already added to their goals stays there. ' +
    'You can invite them again later.'
